import config from '../progetty.config.json'

export const API_URL: string = config.apiurl

export const BASEPATH: string = ''
export const isTouchScreen = function isTouchDevice() {
    return 'ontouchstart' in window || navigator.maxTouchPoints > 0
}
